export const participationExplanation =
  'Ending participation leaves all scheduled games and management parents unchanged.'
